export default "__VITE_ASSET__CfS8Gj_J__"